// extracted by mini-css-extract-plugin
export default {"top":"Top_top__+dHDJ","cover":"Top_cover__lCMib"};